import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRightUpCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-right-up-circle"><path d="M12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 14.25V8.75H9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 15.25L14.5694 9.43054" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowRightUpCircle;
